<template>
    <div>
        <img alt="" v-for="(item,index) in list" :key="index" :src="img.src">
    </div>
</template>

<script>
    export default {
        name: 'Banner',
        props: {
            list: Array
        }
    }
</script>
<style scoped lang="less">
    @import 'banner';
</style>
